import React from 'react';
import { UserIcon, CheckCircleIcon } from '@heroicons/react/24/outline';

interface StaffCardProps {
  id: string;
  name: string;
  phone?: string;
  email?: string;
  isSelected?: boolean;
  onClick: () => void;
}

const StaffCard: React.FC<StaffCardProps> = ({
  name,
  phone,
  email,
  isSelected = false,
  onClick,
}) => {
  return (
    <div
      onClick={onClick}
      className={`cursor-pointer rounded-lg border-2 p-6 transition-all duration-200 hover:shadow-lg hover:scale-[1.02] ${
        isSelected
          ? 'border-brand-600 dark:border-brand-500 bg-brand-50 dark:bg-brand-900/30 shadow-md'
          : 'border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-800 hover:border-brand-400 dark:hover:border-brand-600'
      }`}
    >
      <div className="flex items-center space-x-4">
        {/* 頭像 */}
        <div className={`flex-shrink-0 w-16 h-16 rounded-full flex items-center justify-center ${
          isSelected ? 'bg-brand-100 dark:bg-brand-800' : 'bg-gray-200 dark:bg-slate-700'
        }`}>
          <UserIcon className={`w-8 h-8 ${
            isSelected ? 'text-brand-600 dark:text-brand-400' : 'text-gray-500 dark:text-gray-400'
          }`} />
        </div>

        {/* 資訊 */}
        <div className="flex-1 min-w-0">
          <h3 className={`text-lg font-bold mb-1 ${
            isSelected ? 'text-brand-900 dark:text-brand-100' : 'text-gray-900 dark:text-white'
          }`}>
            {name}
          </h3>

          {phone && (
            <p className={`text-sm truncate ${
              isSelected ? 'text-brand-700 dark:text-brand-300' : 'text-gray-600 dark:text-gray-400'
            }`}>
              {phone}
            </p>
          )}

          {email && (
            <p className={`text-sm truncate ${
              isSelected ? 'text-brand-700 dark:text-brand-300' : 'text-gray-600 dark:text-gray-400'
            }`}>
              {email}
            </p>
          )}
        </div>

        {/* 已選擇圖示 */}
        {isSelected && (
          <div className="flex-shrink-0">
            <CheckCircleIcon className="w-8 h-8 text-brand-600 dark:text-brand-400" />
          </div>
        )}
      </div>
    </div>
  );
};

export default StaffCard;
